<template>
  <div ref="adContainer" :style="{ height: containerHeight }" v-if="!verticalSticky" :id="getIndex" :data-fuse="getIndex" :class="['programmatic-fuse-ad', { 'no-margin' : noMargin }, { 'mar-bottom-20' : bottomMargin }, { 'no-top-margin' : noTopMargin}, { 'force-728' : forceFluid  }, { 'vertical-sticky' : verticalSticky } ]">
  </div>
  <div v-else class="h-100 row">
    <div class="vertical-sticky">
      <div ref="stickyAdContainer" :id="getIndex" :data-fuse="getIndex" :class="['programmatic-fuse-ad', { 'no-margin' : noMargin }, { 'mar-bottom-20' : bottomMargin }, { 'no-top-margin' : noTopMargin}, { 'force-728' : forceFluid  }]">
      </div>
    </div>
  </div>
</template>
<script>
  /* global googletag */
  /* eslint no-undef: "error" */

  export default {
    name: 'ProgrammaticFuseAdsComponent',
    computed: {
      getIndex () {
        return `${this.name}`
      }
    },
    props: {
      noMargin: {
        type: Boolean,
        default: false
      },
      bottomMargin: {
        type: Boolean,
        default: false
      },
      noTopMargin: {
        type: Boolean,
        default: false
      },
      forceFluid: {
        type: Boolean,
        default: false
      },
      name: {
        type: String,
        default: '',
        required: true
      },
      verticalSticky: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        containerHeight: 'auto',
        observer: null
      }
    },
    beforeDestroy() {
      if (this.observer) {
        this.observer.disconnect()
      }
    },
    mounted () {
      this.$emit('ad-loaded', { name: this.name })
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList" && mutation.addedNodes && mutation.addedNodes.length) {
            for (let i = 0; i < mutation.addedNodes.length; i++) {
              const node = mutation.addedNodes[i]
              if (node.tagName && node.tagName.toLowerCase() === 'iframe') {
                node.addEventListener('load', () => {
                  const computedHeight = node.getAttribute('height')
                  node.style.setProperty('height', computedHeight + 'px', 'important')
                })
              }
            }
          }
        })
      })
      if (this.$refs.adContainer) {
        this.observer.observe(this.$refs.adContainer, {
          childList: true,
          subtree: true
        })
      }
      if (this.$refs.stickyAdContainer) {
        this.observer.observe(this.$refs.stickyAdContainer, {
          childList: true,
          subtree: true
        })
      }
    },
    methods: {
      pushDefinition () {
        let that = this
        window.googletag.cmd.push(() => {
          let slot = window.googletag.defineSlot(that.adObject.slotName, that.adObject.slotParams, that.getIndex)
          if (slot !== null) {
            let slotService = slot.addService(googletag.pubads().addEventListener('slotRenderEnded', (event) => {
              if (event.size !== null) {
                let _el = document.getElementById(that.getIndex)
                if (_el !== null) {
                  let _frame = _el.getElementsByTagName('div').item(0).firstElementChild
                  if (_frame !== null) {
                    const height = _frame.getAttribute('height')
                    const width = _frame.getAttribute('width')
                    const _id = _frame.getAttribute('id')
                    document.getElementById(_id).style.height = `${height}px`
                    document.getElementById(_id).style.width = `${width}px`
                  }
                }
              }
            }))
            slotService.setTargeting('Pos', that.adObject.targetingParams.Pos)
            slotService.setTargeting('SlotName', that.adObject.targetingParams.SlotName)
            window.googletag.enableServices()
            window.googletag.display(that.getIndex)
          }
        })
        this.$emit('ad-loaded')
      }
    }
  }
</script>
<style scoped>
  .programmatic-fuse-ad {
    margin: 30px auto 30px auto;
    /* max-width: 970px!important; */
    /* min-height: 600px; */
    /* max-height: 600px!important; */
    /* min-height: 50px!important; */
    /* min-width: 120px!important; */
    /*border: 1px solid green;*/
    display: block;
    width: 100%;
    height: auto; /* Let the height adjust based on content */
    overflow: visible;
  }

  .programmatic-ad.no-margin {
    margin: 0 auto;
  }

  .mar-bottom-20 {
    margin-bottom: 20px;
  }

  .no-top-margin {
    margin-top: 0;
  }

  .force-728 {
    display: block;
    width: 728px;
  }

  .vertical-sticky {
    top: 100px;
    position: sticky;
    height: 600px;
  }

  .h-100 {
    height: 100% !important;
  }

  .row {
    --bs-gutter-x: 1.5rem;
    --bs-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(var(--bs-gutter-y)* -1);
    margin-right: calc(var(--bs-gutter-x)* -.5);
    margin-left: calc(var(--bs-gutter-x)* -.5);
  }

  .row > * {
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
    padding-right: calc(var(--bs-gutter-x)* .5);
    padding-left: calc(var(--bs-gutter-x)* .5);
    margin-top: var(--bs-gutter-y);
  }

</style>




// WEBPACK FOOTER //
// src/components/ProgrammaticFuseAds.vue